module.exports = __webpack_public_path__ + "static/media/T-shirt_pink.4c88058e.svg";